import { renderLocationSidebar } from './locationSidebar';

export const CREATE_EVENT_TEMPLATE = `
<div class="flex min-h-screen overflow-hidden bg-background-light">
${renderLocationSidebar('events')}
<main class="ml-64 flex-1 flex flex-col min-h-screen">
  <header class="bg-white border-b border-slate-200 px-8 py-4">
    <nav class="flex items-center gap-2 text-xs font-medium text-slate-400 uppercase tracking-wider mb-1">
      <a class="hover:text-primary transition-colors" href="/events">Events</a>
      <span class="material-symbols-outlined text-xs">chevron_right</span>
      <span class="text-slate-600">Create New Event</span>
    </nav>
    <h1 class="text-2xl font-extrabold text-slate-900 tracking-tight">Create New Event</h1>
  </header>

  <div class="flex-1 overflow-y-auto p-8 pb-32">
    <div id="create-event-alert" class="hidden max-w-4xl mx-auto mb-6 items-start gap-4 p-4 rounded-xl border bg-rose-50 border-rose-200">
      <span class="material-symbols-outlined text-rose-600">error</span>
      <div>
        <p class="text-sm font-semibold text-rose-800" id="create-event-alert-title">Request failed</p>
        <p class="text-sm text-rose-700 opacity-80" id="create-event-alert-text">Please review form fields.</p>
      </div>
    </div>

    <form id="create-event-form" class="max-w-4xl mx-auto space-y-8">
      <section class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        <div class="p-6 border-b border-slate-100">
          <h3 class="text-lg font-bold text-slate-900 flex items-center gap-2">
            <span class="material-symbols-outlined text-primary">info</span>
            General Info
          </h3>
        </div>
        <div class="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="md:col-span-2">
            <label class="block text-sm font-semibold text-slate-700 mb-1">Event Title</label>
            <input id="event-title" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary" placeholder="e.g. Annual Coastal Mountain Run 2024" />
          </div>
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-1">URL Slug</label>
            <div class="flex rounded-lg shadow-sm">
              <span class="inline-flex items-center px-3 rounded-l-lg border border-r-0 border-slate-200 bg-slate-50 text-slate-500 text-sm">motojourney.com/</span>
              <input id="event-slug" class="flex-1 h-11 rounded-none rounded-r-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary" placeholder="annual-coastal-run" />
            </div>
          </div>
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-1">Event Type</label>
            <select id="event-type" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary">
              <option value="">Select event type</option>
            </select>
          </div>
          <div class="md:col-span-2">
            <label class="block text-sm font-semibold text-slate-700 mb-1">Description</label>
            <textarea id="event-description" class="w-full rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary" rows="4" placeholder="Tell riders what to expect from this journey..."></textarea>
          </div>
          <div class="md:col-span-2">
            <label class="block text-sm font-semibold text-slate-700 mb-1">Structured Content (blocks_v1)</label>
            <div id="event-content-blocks-editor" class="rounded-lg border border-slate-200 bg-white p-3"></div>
            <textarea id="event-content-blocks" class="hidden" rows="1"></textarea>
          </div>
          <div class="md:col-span-2">
            <label class="block text-sm font-semibold text-slate-700 mb-1">Origin</label>
            <div class="flex gap-4 mt-2">
              <label class="flex items-center gap-2 cursor-pointer">
                <input checked class="text-primary focus:ring-primary" name="event-origin" type="radio" value="official"/>
                <span class="text-sm font-medium text-slate-700">Official MotoJourney Event</span>
              </label>
              <label class="flex items-center gap-2 cursor-pointer">
                <input class="text-primary focus:ring-primary" name="event-origin" type="radio" value="community"/>
                <span class="text-sm font-medium text-slate-700">Community Organized</span>
              </label>
            </div>
          </div>
        </div>
      </section>

      <section class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        <div class="p-6 border-b border-slate-100">
          <h3 class="text-lg font-bold text-slate-900 flex items-center gap-2">
            <span class="material-symbols-outlined text-primary">schedule</span>
            Schedule
          </h3>
        </div>
        <div class="p-6 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-1">Starts at</label>
            <input id="event-starts-at" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary" type="datetime-local" />
          </div>
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-1">Ends at</label>
            <input id="event-ends-at" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary" type="datetime-local" />
          </div>
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-1">Timezone</label>
            <select id="event-timezone" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary">
              <option>(GMT+03:00) Europe/Minsk</option>
              <option>(GMT+00:00) UTC</option>
              <option>(GMT+01:00) Central European</option>
            </select>
          </div>
        </div>
      </section>

      <section class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        <div class="p-6 border-b border-slate-100">
          <h3 class="text-lg font-bold text-slate-900 flex items-center gap-2">
            <span class="material-symbols-outlined text-primary">location_on</span>
            Geographic Location
          </h3>
        </div>
        <div class="p-6 grid grid-cols-1 md:grid-cols-12 gap-6">
          <div class="md:col-span-12 relative h-48 rounded-lg border border-slate-200 overflow-hidden bg-slate-100">
            <div id="event-map" class="absolute inset-0 z-0"></div>
            <div id="event-map-placeholder" class="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div class="bg-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2 border border-slate-200">
                <span class="material-symbols-outlined text-primary">pin_drop</span>
                <span class="text-xs font-bold text-slate-700">Map loading...</span>
              </div>
            </div>
          </div>
          <div class="md:col-span-6">
            <label class="block text-sm font-semibold text-slate-700 mb-1">Location Name</label>
            <input id="event-location-name" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary" placeholder="e.g. Starpoint Rally Base" />
          </div>
          <div class="md:col-span-6">
            <label class="block text-sm font-semibold text-slate-700 mb-1">Settlement</label>
            <select id="event-settlement" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary">
              <option value="">Select settlement</option>
            </select>
          </div>
          <div class="md:col-span-4">
            <label class="block text-sm font-semibold text-slate-700 mb-1">County / District</label>
            <select id="event-county" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary">
              <option value="">Select county</option>
            </select>
          </div>
          <div class="md:col-span-4">
            <label class="block text-sm font-semibold text-slate-700 mb-1">Region</label>
            <select id="event-region" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary">
              <option value="">Select region</option>
            </select>
          </div>
          <div class="md:col-span-4">
            <label class="block text-sm font-semibold text-slate-700 mb-1">Country</label>
            <select id="event-country" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary">
              <option value="">Select country</option>
            </select>
          </div>
          <div class="md:col-span-6">
            <label class="block text-sm font-semibold text-slate-700 mb-1">Latitude</label>
            <input id="event-latitude" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary" value="34.4208" />
          </div>
          <div class="md:col-span-6">
            <label class="block text-sm font-semibold text-slate-700 mb-1">Longitude</label>
            <input id="event-longitude" class="w-full h-11 rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary" value="-119.6982" />
          </div>
        </div>
      </section>

      <section class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        <div class="p-6 border-b border-slate-100">
          <h3 class="text-lg font-bold text-slate-900 flex items-center gap-2">
            <span class="material-symbols-outlined text-primary">settings_input_component</span>
            Event Settings
          </h3>
        </div>
        <div class="p-6 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div class="space-y-6">
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">Max Capacity</label>
              <input id="event-capacity" class="w-full rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary h-11" placeholder="No limit" type="number"/>
              <p class="mt-1 text-xs text-slate-500">Number of rider slots available.</p>
            </div>
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">Starting Price (USD)</label>
              <div class="relative">
                <span class="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">$</span>
                <input id="event-price-from" class="pl-8 w-full rounded-lg border border-slate-200 bg-slate-50 focus:border-primary focus:ring-primary h-11" type="number" value="0"/>
              </div>
            </div>
          </div>
          <div class="space-y-6 flex flex-col justify-center">
            <div class="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-100">
              <div>
                <p class="text-sm font-bold text-slate-800">Is Free Event</p>
                <p class="text-xs text-slate-500">Tickets are complimentary.</p>
              </div>
              <label class="relative inline-flex items-center cursor-pointer">
                <input id="event-is-free" class="sr-only peer" type="checkbox"/>
                <span class="w-11 h-6 bg-slate-200 rounded-full relative peer peer-checked:bg-primary after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:size-5 after:bg-white after:rounded-full after:transition-all peer-checked:after:translate-x-full"></span>
              </label>
            </div>
            <div class="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-100">
              <div>
                <p class="text-sm font-bold text-slate-800">Featured Event</p>
                <p class="text-xs text-slate-500">Promote on the homepage.</p>
              </div>
              <label class="relative inline-flex items-center cursor-pointer">
                <input id="event-is-featured" checked class="sr-only peer" type="checkbox"/>
                <span class="w-11 h-6 bg-slate-200 rounded-full relative peer peer-checked:bg-primary after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:size-5 after:bg-white after:rounded-full after:transition-all peer-checked:after:translate-x-full"></span>
              </label>
            </div>
          </div>
        </div>
      </section>

      <section class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        <div class="p-6 border-b border-slate-100">
          <h3 class="text-lg font-bold text-slate-900 flex items-center gap-2">
            <span class="material-symbols-outlined text-primary">image</span>
            Media Assets
          </h3>
        </div>
        <div class="p-6 space-y-8">
          <div>
            <h4 class="text-sm font-bold text-slate-700 mb-3">Cover Image</h4>
            <label for="event-cover-file" class="border-2 border-dashed border-slate-200 rounded-xl p-8 flex flex-col items-center justify-center bg-slate-50/50 hover:bg-primary/5 hover:border-primary/50 transition-all cursor-pointer group">
              <div class="bg-white size-12 rounded-full flex items-center justify-center shadow-sm mb-4 group-hover:scale-110 transition-transform">
                <span class="material-symbols-outlined text-primary">upload</span>
              </div>
              <p class="text-sm font-semibold text-slate-800">Click to upload or drag and drop</p>
              <p class="text-xs text-slate-500 mt-1">Hero image for the event listing (min. 1200x600px)</p>
            </label>
            <input id="event-cover-file" type="file" class="hidden" accept="image/*"/>
            <p id="event-cover-file-name" class="mt-2 text-xs text-slate-500"></p>
            <div id="event-cover-preview" class="mt-3"></div>
          </div>
          <div>
            <h4 class="text-sm font-bold text-slate-700 mb-3">Photo Gallery</h4>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
              <label for="event-gallery-files" class="aspect-square border-2 border-dashed border-slate-200 rounded-xl flex items-center justify-center bg-slate-50/50 hover:bg-primary/5 hover:border-primary/50 transition-colors cursor-pointer">
                <span class="material-symbols-outlined text-slate-300">add</span>
              </label>
              <input id="event-gallery-files" type="file" class="hidden" accept="image/*" multiple/>
              <div id="event-gallery-preview" class="contents"></div>
            </div>
            <p id="event-gallery-file-name" class="mt-2 text-xs text-slate-500"></p>
          </div>
        </div>
      </section>
    </form>
  </div>

  <footer class="fixed bottom-0 left-64 right-0 bg-white border-t border-slate-200 px-8 py-5 flex items-center justify-between z-50 shadow-[0_-4px_6px_-1px_rgb(0_0_0_/_0.1)]">
    <div class="flex items-center gap-4 text-sm font-medium text-slate-400">
      <span class="flex items-center gap-1.5"><span class="size-2 rounded-full bg-slate-300"></span> Last auto-saved: 2m ago</span>
    </div>
    <div id="event-actions" class="invisible flex items-center gap-3">
      <button id="event-cancel-btn" type="button" class="px-5 py-2.5 rounded-lg border border-slate-200 text-slate-600 font-semibold hover:bg-slate-50 transition-all text-sm">Cancel</button>
      <button id="event-import-json-btn" type="button" class="px-5 py-2.5 rounded-lg bg-slate-100 text-slate-800 font-semibold hover:bg-slate-200 transition-all text-sm inline-flex items-center gap-2">
        <span class="material-symbols-outlined text-sm">upload_file</span>
        Import JSON
      </button>
      <button id="event-save-draft-btn" type="button" class="px-5 py-2.5 rounded-lg bg-slate-100 text-slate-800 font-semibold hover:bg-slate-200 transition-all text-sm">Save Draft</button>
      <button id="event-publish-btn" type="button" class="px-8 py-2.5 rounded-lg bg-primary text-white font-bold shadow-lg shadow-primary/25 hover:bg-blue-600 transition-all text-sm">Publish Event</button>
    </div>
  </footer>
</main>
</div>
`;
